(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-pre-order"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    var countdownElements = document.querySelectorAll('.preorder--countdown .preorder--countdown--time');

    countdownElements.forEach(function (element, index) {
      var targetDate = new Date(element.getAttribute('data-heure'));
      var countdownTimer = document.querySelectorAll('.preorder--countdown .preorder--countdown--time')[index];

      function updateCountdown() {
        var currentDate = new Date();
        var timeDifference = targetDate - currentDate;

        var days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
        var hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));

        countdownTimer.innerHTML = 
        '<span class="date-elm">' + days + '<span>Jours </span>' + '</span>' + ' <span class="colon">:</span> ' + 
        '<span class="date-elm">' + hours + '<span>Heures </span>' + '</span>' + ' <span class="colon">:</span> ' +
        '<span class="date-elm">' + minutes + '<span>Minutes </span>' + '</span>';
      }

      updateCountdown();
      setInterval(updateCountdown, 1000);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
